import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import siteMessage from "@insite/client-framework/SiteMessage";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import safeColor from "@insite/mobius/utilities/safeColor";
import React from "react";
import styled, { css } from "styled-components";

interface OwnProps {
    isDropShipItem: boolean;
}

export interface ProductDropShipMessageStyles {
    messageWrapper?: InjectableCss;
    messageText?: TypographyPresentationProps;
}

const DropShipMessage = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    padding: 5px;
    border-radius: 5px;
    background-color: ${props => safeColor(resolveColor(props.color, props.theme)).rgb().alpha(0.2).string()};
    ${IconWrapper} {
        margin-right: 10px;
    }
`;

export const dropShipItemStyles: ProductDropShipMessageStyles = {
    messageText: {
        css: css`
            width: 100%;
            ${wrapInContainerStyles}
        `,
    },
};

const DropShipItemMessage: React.FC<OwnProps> = ({ isDropShipItem }) => {

    if (!isDropShipItem) {
        return null;
    }

    return (
        <DropShipMessage color="success">
            <Icon color="success" src={Check} />
            <Typography {...dropShipItemStyles.messageText}>{siteMessage("ProductIsDropShipItem")}</Typography>
        </DropShipMessage>
    );
};

export default DropShipItemMessage;
